<div class="login-card">
  @if (loading) {
    <div class="loading-spinner-wrapper">
      <mat-spinner class="loading-spinner" [diameter]="32"></mat-spinner>
      Signing in...
    </div>
  } @else {
    <div class="local-dev-info">Local Development - {{ environment | titlecase }}</div>

    <div class="login-wrapper">
      <img class="logo" alt="Vendasta" height="auto" width="140px" src="/static/images/vendasta-logo-large.png" />

      <form #form="ngForm" (ngSubmit)="login(form)">
        <glxy-form-field bottomSpacing="small" [showLabel]="false" size="large">
          <glxy-label>Email</glxy-label>
          <input matInput placeholder="Email" name="email" [(ngModel)]="email" />
        </glxy-form-field>

        <glxy-form-field [showLabel]="false" size="large" bottomSpacing="small">
          <glxy-label>Password</glxy-label>
          <input matInput placeholder="Password" type="password" name="password" [(ngModel)]="password" />
        </glxy-form-field>

        <div class="sso-separator">
          <span class="sso-separator-or">or</span>
        </div>

        <!--Option to enter partner ID and session token-->

        <glxy-form-field [showLabel]="false" size="large" bottomSpacing="small">
          <glxy-label>Partner ID</glxy-label>
          <input
            matInput
            placeholder="Partner ID"
            name="partnerId"
            [(ngModel)]="partnerId"
            oninput="this.value = this.value.toUpperCase()"
          />
        </glxy-form-field>

        <glxy-form-field [showLabel]="false" size="large">
          <glxy-label>Session Token</glxy-label>
          <input
            matInput
            placeholder="Session Token ({{ environment | titlecase }})"
            name="sessionToken"
            [(ngModel)]="sessionToken"
          />
        </glxy-form-field>

        <button class="login-button" type="submit" mat-flat-button color="primary">Sign In</button>
      </form>

      <div class="sso-separator">
        <span class="sso-separator-or">or</span>
      </div>

      <button mat-stroked-button class="google-sso-button" (click)="loginWithGoogle()">
        <div class="google-sso-content">
          <svg
            class="google-sso-logo"
            width="26px"
            height="26px"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30 18.8324C32.6933 18.827 35.2965 19.8016 37.324 21.5744L42.691 16.2074C40.5598 14.2446 38.0026 12.8025 35.2203 11.9942C32.4379 11.186 29.5061 11.0336 26.6549 11.5491C23.8038 12.0646 21.1109 13.2338 18.7877 14.9651C16.4644 16.6964 14.5741 18.9426 13.265 21.5274L19.441 26.3274C20.2054 24.1367 21.6326 22.2381 23.5246 20.8951C25.4167 19.5521 27.6798 18.8312 30 18.8324V18.8324Z"
              fill="#DA3237"
            />
            <path
              d="M48.75 29.9999C48.7481 28.8842 48.65 27.7707 48.457 26.6719H30.293V33.7029H40.547C39.7309 36.0113 38.184 37.9904 36.141 39.3399L42.317 44.1399C44.337 42.3792 45.9564 40.2062 47.0661 37.7672C48.1758 35.3281 48.7499 32.6795 48.75 29.9999Z"
              fill="#4483EC"
            />
            <path
              d="M18.832 30.0012C18.8323 28.7524 19.0422 27.5125 19.453 26.3332L13.277 21.5332C11.9286 24.1905 11.2337 27.1313 11.25 30.1111C11.2664 33.0909 11.9935 36.0238 13.371 38.6662L19.523 33.8732C19.0583 32.6355 18.8241 31.3232 18.832 30.0012V30.0012Z"
              fill="#F3C210"
            />
            <path
              d="M30.0001 41.1679C27.7183 41.1686 25.491 40.4705 23.6179 39.1673C21.7448 37.8642 20.3158 36.0186 19.5231 33.8789L13.3711 38.6719C14.6833 41.1849 16.5478 43.3678 18.8247 45.0568C21.1016 46.7457 23.7316 47.8968 26.5172 48.4235C29.3027 48.9502 32.1714 48.8388 34.9078 48.0978C37.6441 47.3567 40.177 46.0053 42.3161 44.1449L36.1401 39.3449C34.317 40.5427 32.1814 41.1768 30.0001 41.1679V41.1679Z"
              fill="#3DBB55"
            />
          </svg>
          Sign in with Google
        </div>
      </button>
    </div>
  }
</div>
